import { createContext, type ReactNode, useContext } from 'react';
import type { RunnerData } from '@/adapters/auth';
import type { RaceConfig } from '../types';

interface RaceContextType {
  race: RaceConfig;
  runner: RunnerData | null;
  setRunner: (runner: RunnerData | null) => void;
}

const RaceContext = createContext<RaceContextType | null>(null);

interface RaceProviderProps {
  children: ReactNode;
  race: RaceConfig;
  runner: RunnerData | null;
  setRunner: (runner: RunnerData | null) => void;
}

export function RaceProvider({ children, race, runner, setRunner }: RaceProviderProps) {
  return <RaceContext.Provider value={{ race, runner, setRunner }}>{children}</RaceContext.Provider>;
}

export function useRace() {
  const context = useContext(RaceContext);
  if (!context) {
    throw new Error('useRace must be used within a RaceProvider');
  }
  return context;
}
